const ENV = (typeof window !== "undefined" && window.BARKODER_ENV) || process.env.ENV || "live";
const HOME_URL = (typeof window !== "undefined" && window.home_url) || process.env.home_url || process.env.HOME_URL || "/";
const WEB_USERNAME = process.env.WEB_USERNAME;
const WEB_PASS = process.env.WEB_PASS;
const recaptcha_site_key = process.env.recaptcha_site_key
const recaptcha_v2_site_key = process.env.recaptcha_v2_site_key

export {
	ENV,
	HOME_URL,
	WEB_USERNAME,
	WEB_PASS,
	recaptcha_site_key,
	recaptcha_v2_site_key
};